export const MuiMenuItem = {
  styleOverrides: {
    root: {
      paddingTop: '11px',
      paddingBottom: '11px',
    },
  },
};
